<script lang="ts">
  import { ship } from "../net/ship.svelte.js";
  import { session } from "../net/session.svelte.js";
  import { send } from "../net/intents.js";

  const snap = $derived(ship.snap!);
  const r = $derived(snap.relay);
</script>

<div class="console">
  <h3>STORAGE — SPARES LOCKER</h3>
  {#if r.status === "damaged"}
    <p class="warn">INTERCOM RELAY (SPARE) — ONE IN STOCK. SOCKET AT BRIDGE CONSOLE.</p>
    <button onclick={() => send("replace.take", {})}>TAKE SPARE RELAY</button>
  {:else if r.status === "carried"}
    <p class="dim">SPARE RELAY CHECKED OUT BY {r.carrier === session.sessionId ? "YOU" : (snap.crew[r.carrier]?.name ?? "A CREW MEMBER")}.</p>
  {:else}
    <p class="dim">NOTHING REQUISITIONED. THE LOCKER IS INVENTORIED QUARTERLY.</p>
  {/if}
</div>

<style>
  .console { display: grid; gap: 0.6rem; border: 1px solid var(--fg-dim); padding: 0.7rem; }
  button { min-height: 56px; }
</style>
